<template>
  <div class="not-found">
    <a-result
      status="404"
      title="404"
      sub-title="抱歉，您访问的页面不存在"
    >
      <template #extra>
        <!-- <a-button type="primary" @click="goHome">
          返回首页
        </a-button> -->
      </template>
    </a-result>
  </div>
</template>

<script>
import { Result, Button } from 'ant-design-vue'

export default {
  name: 'NotFound',
  components: {
    AResult: Result,
    AButton: Button
  },
  methods: {
    goHome () {
      this.$router.push({ name: 'Trial' })
    }
  }
}
</script>

<style scoped>
.not-found {
  min-height: calc(100vh - 102px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
